import { render, staticRenderFns } from "./igt-tab.vue?vue&type=template&id=432a3832&scoped=true&"
import script from "./igt-tab.vue?vue&type=script&lang=js&"
export * from "./igt-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a3832",
  null
  
)

export default component.exports